export default [
  {
    name: "Život mezi řádky",
    link: "https://www.zivotmeziradky.cz/",
    image: require("./assets/projects/zivotmeziradky.jpg")
  },
  {
    name: "Obec Opatov",
    link: "https://www.obecopatov.cz/",
    image: require("./assets/projects/obecopatov.jpg")
  },
  {
    name: "Dřevojas",
    link: "https://www.drevojas.cz/",
    image: require("./assets/projects/drevojas.jpg")
  },
  {
    name: "Palmyra Tour",
    link: "https://www.palmyratour.cz/",
    image: require("./assets/projects/palmyratour.jpg")
  },
  {
    name: "Nopek",
    link: "https://www.nopek.cz/",
    image: require("./assets/projects/nopek.jpg")
  },
  {
    name: "Drillo",
    link: "https://www.drillo.cz/",
    image: require("./assets/projects/drillo.jpg")
  },
  {
    name: "Finext",
    link: "https://www.finext.cz/",
    image: require("./assets/projects/finext.jpg")
  },
  {
    name: "Zámecký catering",
    link: "https://www.zamecky-catering.cz/",
    image: require("./assets/projects/zamecky-catering.jpg")
  },
  {
    name: "Velcar",
    link: "https://www.velcar.cz//",
    image: require("./assets/projects/velcar.jpg")
  },
  {
    name: "Eccedu",
    link: "https://www.eccedu.org/",
    image: require("./assets/projects/eccedu.jpg")
  },
  {
    name: "Suspect Animal",
    link: "https://www.suspectanimal.cz/",
    image: require("./assets/projects/suspectanimal.jpg")
  },
  {
    name: "Kynologie Javorka",
    link: "https://www.kynologiejavorka.cz/",
    image: require("./assets/projects/kynologiejavorka.jpg")
  },
  {
    name: "Haly HWT",
    link: "http://www.haly-hwt.cz/",
    image: require("./assets/projects/haly-hwt.jpg")
  },
  {
    name: "Anna Ptáčníková",
    link: "https://www.ptaa.cz/",
    image: require("./assets/projects/ptaa.jpg")
  },
  {
    name: "Kuchyně Glanc",
    link: "https://www.glanckuchyne.cz/",
    image: require("./assets/projects/glanckuchyne.jpg")
  },
  {
    name: "Etan",
    link: "https://www.etan.cz/",
    image: require("./assets/projects/etan.jpg")
  },
  {
    name: "FA Havlíček",
    link: "http://www.fa-havlicek.cz/",
    image: require("./assets/projects/fa-havlicek.jpg")
  },
  {
    name: "Shiba Klub",
    link: "https://www.shiba-klub.cz/",
    image: require("./assets/projects/shiba-klub.jpg")
  },
  {
    name: "Tribona",
    link: "https://www.tribona.cz/",
    image: require("./assets/projects/tribona.jpg")
  },
  {
    name: "Symbiom",
    link: "https://www.symbiom.cz/",
    image: require("./assets/projects/symbiom.jpg")
  },
  {
    name: "Force Production",
    link: "https://www.forceproduction.cz/",
    image: require("./assets/projects/forceproduction.jpg")
  },
  {
    name: "Veterinář Palán",
    link: "http://www.veterinar-palan.cz/",
    image: require("./assets/projects/veterinar-palan.jpg")
  },
  {
    name: "Zahradní krby Věříš",
    link: "https://www.zahradnikrbyveris.cz/",
    image: require("./assets/projects/zahradnikrbyveris.jpg")
  },
  {
    name: "Chytré střechy",
    link: "https://www.chytrestrechy.cz/",
    image: require("./assets/projects/chytrestrechy.jpg")
  },
  {
    name: "Krejsa",
    link: "https://www.krejsashop.cz/",
    image: require("./assets/projects/krejsashop.jpg")
  },
  {
    name: "Auto Synek",
    link: "https://www.autosynek.cz/",
    image: require("./assets/projects/autosynek.jpg")
  },
  {
    name: "Penzion U Synka",
    link: "https://www.penzionusynka.cz/",
    image: require("./assets/projects/penzionusynka.jpg")
  },
  {
    name: "Beauty Siluet",
    link: "http://www.beauty-siluet.cz/",
    image: require("./assets/projects/beauty-siluet.jpg")
  },
  {
    name: "Emagra",
    link: "http://www.emagra.cz/",
    image: require("./assets/projects/emagra.jpg")
  },
  {
    name: "Salten",
    link: "http://www.salten.cz/",
    image: require("./assets/projects/salten.jpg")
  },
  {
    name: "Tom zálesáci",
    link: "http://www.zalesaci.net/",
    image: require("./assets/projects/zalesaci.jpg")
  },
  {
    name: "Hotel Aplaus",
    link: "http://www.hotelaplaus.cz/",
    image: require("./assets/projects/hotelaplaus.jpg")
  },
  {
    name: "PZP",
    link: "http://www.pzp.cz/",
    image: require("./assets/projects/pzp.jpg")
  },
  {
    name: "Vetvill",
    link: "http://www.vetvill.cz/",
    image: require("./assets/projects/vetvill.jpg")
  },
  {
    name: "Firmstyle",
    link: "https://www.firmstyle.cz/",
    image: require("./assets/projects/firmstyle.jpg")
  },
  {
    name: "Uvažujte",
    link: "https://www.uvazujte.cz/",
    image: require("./assets/projects/uvazujte.jpg")
  },
  {
    name: "LQZ",
    link: "http://www.lqz.cz/",
    image: require("./assets/projects/lqz.jpg")
  },
  {
    name: "Hostálek",
    link: "http://www.hostalek.cz/",
    image: require("./assets/projects/hostalek.jpg")
  },
  {
    name: "Truhlář Vrána",
    link: "http://www.truhlarvrana.cz/",
    image: require("./assets/projects/truhlarvrana.jpg")
  },
  {
    name: "Nové Hrady",
    link: "http://www.nove-hrady.cz/",
    image: require("./assets/projects/nove-hrady.jpg")
  },
  {
    name: "Kempy Martina Koukala",
    link: "https://www.martinkoukal.cz/",
    image: require("./assets/projects/martinkoukal.jpg")
  },
  {
    name: "Mossy",
    link: "https://www.mossy.cz/",
    image: require("./assets/projects/mossy.jpg")
  },
  {
    name: "Festival Rosnička",
    link: "http://www.festivalrosnicka.cz/",
    image: require("./assets/projects/festivalrosnicka.jpg")
  },
  {
    name: "ZS Opatov",
    link: "https://www.zs-opatov.cz/",
    image: require("./assets/projects/zs-opatov.jpg")
  },
  {
    name: "Configurator Bokiheat",
    link: "http://configurator.bokiheat.eu/",
    image: require("./assets/projects/configurator.bokiheat.jpg")
  }
];
